import { ReflectionRoleEnum } from './reflection-role-enum'

export interface NotificationReviceRoleInterface {
  /**
   * 接收人角色
   */
  role?: ReflectionRoleEnum | null
  /**
   * 接收人集合
   */
  rids?: number[]
  /**
   * 已读接收人集合
   */
  readedRids?: number[]
}

export class NotificationReviceRole implements NotificationReviceRoleInterface {
  /**
   * 接收人角色
   */
  role?: ReflectionRoleEnum | null
  /**
   * 接收人集合
   */
  rids?: number[]
  /**
   * 已读接收人集合
   */
  readedRids?: number[]

  constructor(props: NotificationReviceRoleInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      role: _role,
      rids: _rids,
      readedRids: _readedRids,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.role = _role
    this.rids = _rids
    this.readedRids = _readedRids
  }
}
